/**
 * Koz Comparison Table — mobile product slider (one slide per product column).
 */
(function () {
  function initSlider(root) {
    var track = root.querySelector('[data-koz-comp-track]');
    var slides = root.querySelectorAll('[data-koz-comp-slide]');
    var prevBtns = root.querySelectorAll('[data-koz-comp-prev]');
    var nextBtns = root.querySelectorAll('[data-koz-comp-next]');
    var counter = root.querySelector('[data-koz-comp-counter]');
    var live = root.querySelector('[data-koz-comp-live]');

    if (!track || !slides.length) return;

    var index = 0;
    var total = slides.length;

    function announce(msg) {
      if (live) live.textContent = msg;
    }

    function updateUI() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';

      slides.forEach(function (slide, i) {
        var hidden = i !== index;
        slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        slide.tabIndex = hidden ? -1 : 0;
      });

      if (counter) {
        counter.textContent = index + 1 + ' / ' + total;
      }

      var atStart = index === 0;
      var atEnd = index >= total - 1;

      prevBtns.forEach(function (btn) {
        btn.disabled = atStart;
        btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      });

      nextBtns.forEach(function (btn) {
        btn.disabled = atEnd;
        btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      });

      var titleEl = slides[index].querySelector('.koz-prod-title');
      if (titleEl) {
        announce('Product ' + (index + 1) + ' of ' + total + ': ' + titleEl.textContent.trim());
      }
    }

    function goTo(i) {
      index = Math.max(0, Math.min(total - 1, i));
      updateUI();
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(index - 1);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(index + 1);
      });
    });

    var viewport = root.querySelector('.koz-comp-slider__viewport') || track;
    var dragStartX = 0;
    var isDragging = false;
    var dragThreshold = 40;

    function endDrag(clientX, pointerId) {
      if (!isDragging) return;
      isDragging = false;
      root.classList.remove('koz-comp-slider--dragging');
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) {
        viewport.releasePointerCapture(pointerId);
      }
      var diff = clientX - dragStartX;
      if (Math.abs(diff) < dragThreshold) return;
      if (diff < 0) goTo(index + 1);
      else goTo(index - 1);
    }

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      dragStartX = e.clientX;
      root.classList.add('koz-comp-slider--dragging');
      if (viewport.setPointerCapture) {
        viewport.setPointerCapture(e.pointerId);
      }
    });

    viewport.addEventListener('pointerup', function (e) {
      endDrag(e.clientX, e.pointerId);
    });

    viewport.addEventListener('pointercancel', function (e) {
      endDrag(e.clientX, e.pointerId);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(index + 1);
      }
    });

    updateUI();
  }

  function initAll() {
    document.querySelectorAll('[data-koz-comp-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-koz-comp-slider]');
    if (root) initSlider(root);
  });
})();
